export default "__VITE_ASSET__Bdp3idQJ__"